import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  winRate: {
    a: 0,
    b: 0,
    c: 0,
  },
};

export const lucky77 = createSlice({
  name: "lucky77",
  initialState,
  reducers: {
    changeWinRate: (state, { payload }) => {
      state.winRate = payload;
    },
  },
});

export const { changeWinRate } = lucky77.actions;

export default lucky77.reducer;
